class UnsafeFilter {

  /*@ngInject*/
  static instance() { //static instance function
    let dataFilter = ["$sce", $sce => {
      let filteredObject = (input) => {
        //filter logic
        return $sce.trustAsHtml(input);
      }
      return filteredObject;
    }]
    return dataFilter;
  }
}

UnsafeFilter.$inject = ["$sce"];

export default UnsafeFilter;
